import {equals} from 'remeda';

import {AddressType} from 'desktop/types/addressType';
import {CustomerAddressType} from 'desktop/types/customerAddressesType';
import {StatesItemType} from 'types/locationType';

import {
    applyAssociations,
    customerAddressAssociations,
} from '../../../decomposeAllAddressesByComponents/utils/applyAssociations/applyAssociations';
import {simplifyAddressObject} from '../simplifyAddressObject/simplifyAddressObject';

/**
 * Looking for target address in received addresses array and returns boolean means that target address exists in array
 * @param {Array<CustomerAddressType>} addresses - Received customer addresses from address book
 * @param {AddressType} target - Currently added customer address to comparison with
 * @param {{email: string}} email- Customer email to fallback in case when we can't take email from address
 * @param {{states: Array<StatesItemType>}} state- States that will used for regionCode value modification
 * @return {boolean} - Result of comparison. True - in case when we trying to save address that already exist in address book. False - in another
 */
export const findUsingDeepComparison = (
    addresses: Array<CustomerAddressType>,
    target: AddressType,
    {email, states}: {email: string; states: Array<StatesItemType>},
): boolean =>
    addresses.some((address: CustomerAddressType): boolean => {
        const processedAddress = applyAssociations(customerAddressAssociations, address, {
            email: ({value}) => ({
                value: value || email || '',
            }),
            regionCode: ({value}) => {
                if (states && states.length) {
                    const suitableState = states.find(state => state.value === value);
                    return {
                        value: suitableState ? suitableState.id : states[0].id,
                    };
                }
                return null;
            },
        });

        const finallyProcessedAddress = simplifyAddressObject(processedAddress);
        const finallyProcessedTarget = simplifyAddressObject(target);

        return equals(finallyProcessedAddress, finallyProcessedTarget);
    });
